"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidFormat = exports.isValidMask = void 0;
function isValidMask(value) {
    if (typeof value !== 'string')
        return false;
    return /^(0800 ?\d{3} ?\d{4})$|(\+55 ?\(?(?:[14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])\)? ?(?:[2-8]|9[1-9])[0-9]{3}\-?[0-9]{4})$/.test(value);
}
exports.isValidMask = isValidMask;
function isValidFormat(value) {
    if (typeof value !== 'string' || /\D/.test(value))
        return false;
    if (value.startsWith('0800'))
        return true;
    if (value.length !== 11 && value.length !== 10)
        return false;
    return true;
}
exports.isValidFormat = isValidFormat;
//# sourceMappingURL=phone.js.map